export const ADMIN_SCOPES = {
  ALL: 'all',
  MATCH_PRODUCT: 'match_product',
  EDIT_PRODUCT: 'edit_product',
  EDIT_BRAND: 'edit_brand',
  MANAGE_USERS: 'manage_users',
  MANAGE_CATALOG: 'manage_catalog',
  MANAGE_ANNOUNCEMENTS: 'manage_announcements',
  MANAGE_NEWSLETTERS: 'manage_newsletters',
  MANAGE_GREENHOUSE: 'manage_greenhouse',
  MANAGE_RECOMMENDATIONS: 'manage_recommendations',
  MANAGE_OAUTH_APPLICATIONS: 'manage_oauth_applications',
  MANAGE_PAYOUTS: 'manage_payouts',
  MANAGE_AGENTS: 'manage_agents',
  OFFICE_ADMIN: 'office_admin',
  OFFICE_EXEC: 'office_exec',
  OFFICE_MANAGER: 'office_manager',
  OFFICE_STANDARD: 'office_standard',
  VIEW_STYLE_AUDIT: 'view_style_audit',
  WRITE_MANUAL_ORDER_ADJUSTMENTS: 'write_manual_order_adjustments',
  MANAGE_CHANGELOG: 'manage_changelog',
  PIN_MATCH_AGENTS: 'pin_match_agents',
  MANAGE_SPOTLIGHTS: 'manage_spotlights',
  MANAGE_BLOG: 'manage_blog',
  MANAGE_SHOPPER_SEARCH: 'manage_shopper_search',
  MANAGE_USER_TIPS: 'manage_user_tips',
  MANAGE_MARKETING: 'manage_marketing',
  MANAGE_BRANDS: 'manage_brands',
  MANAGE_INVOICING: 'manage_invoicing',
  RUN_SCRIPTS: 'run_scripts',
  MANAGE_WEBINARS: 'manage_webinars',
  MANAGE_PRODUCT_DROPS: 'manage_product_drops',
  LAUNCH_NOTIFICATIONS: 'launch_notifications',
  REVIEW_HELD_LINKS: 'review_held_links'
};
